var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVirtualservers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 260.39 244.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#1b2d3b"
    },
    cx: 130.19,
    cy: 61.53,
    rx: 85.23,
    ry: 31.09
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b2d3b"
    },
    d: "M45,157.55v32.37c17.88,14.28,49.37,23.76,85.23,23.76s67.36-9.48,85.24-23.76V157.55c-17.88,14.29-49.37,23.77-85.24,23.77S62.84,171.84,45,157.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b2d3b"
    },
    d: "M45,97v32.36c17.88,14.29,49.37,23.77,85.23,23.77s67.36-9.48,85.24-23.77V97c-17.88,14.28-49.37,23.77-85.24,23.77S62.84,111.3,45,97Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualservers);
export default __webpack_public_path__ + "static/media/virtualservers.d9efebfd9bcafc940e3eb0647e670dfe.svg";
export { ForwardRef as ReactComponent };